import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with programming and I have at least learnt
              something, I think… 🤷‍♂️
              <br />
              <br />I am fluent in some languages like
              <i>
                <b className="purple"> Java</b>, <b className="purple">Javascript/Typescript</b> and <b className="purple">Python</b>.
              </i>
              <br />
              <br />
              My field of Interest's are 
              <i>
                Delivering Softwares using the best practices of <b className="purple">DevOps </b> using <b className="purple">Gitlab</b> and <b className="purple">Kubernetes </b> 
              </i>
              as well as building new
              <i>
                <b className="purple">Technologies and Products </b> in both Web and Mobile
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b>, <b className="purple">Django</b> or <b className="purple">Spring Boot</b>
              {" "} and Modern Libraries and Frameworks
              &nbsp;like
              <i>
                <b className="purple"> Next.js and Angular </b>
              </i>
              or mobile dev frameworks like 
              <i>
                <b className="purple"> Java </b> or <b className="purple">React Native</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/oussamaZAAM"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/oussamaZAAM/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
